const sortAssignments = (data: any) => {
  data.sort((a: any, b: any) => {
    if (a.drivers[0].catalog < b.drivers[0].catalog) return -1;
    if (a.drivers[0].catalog > b.drivers[0].catalog) return 1;

    // Ahora se compara por 'number'
    const numberA = parseInt(a.drivers[0].number, 10);
    const numberB = parseInt(b.drivers[0].number, 10);

    const isNumberA = !isNaN(numberA);
    const isNumberB = !isNaN(numberB);

    if (isNumberA && isNumberB) return numberA - numberB;
    else if (isNumberA) return -1;
    else if (isNumberB) return 1;
    else return 0;
  });
};

const getTeamLogo = (team_id: number | string, logo: string | null) => {
  if (logo == null) return team_id;
  else return `${team_id}_${logo}`;
};

const getRandomReportMessage = (flag: string, name: string, link: string) => {
  const messages = [
    `Deep race analysis and full results from ${flag} ${name}: ${link}`,
    `In-depth breakdown of the race plus full results from ${flag} ${name}: ${link}`,
    `Full race analysis, strategy review, and results from ${flag} ${name}: ${link}`,
    `Detailed analysis of the Grand Prix alongside complete race results from ${flag} ${name}: ${link}`,
    `${flag} ${name} breakdown — key moments, strategy analysis, and full results: ${link}`,
    `Comprehensive race analysis and results from ${flag} ${name}: ${link}`,
    `Full post-race analysis, insights, and results from ${flag} ${name}: ${link}`,
    `Everything from ${flag} ${name}: strategy analysis, key battles, and full results: ${link}`,
  ];
  return messages[Math.floor(Math.random() * messages.length)];
};
export { sortAssignments, getTeamLogo, getRandomReportMessage };
